import { render, staticRenderFns } from "./AddDocumentButtons.vue?vue&type=template&id=20ad65ce&"
import script from "./AddDocumentButtons.vue?vue&type=script&lang=js&"
export * from "./AddDocumentButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports